import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Eye } from 'lucide-react';

const HERO_IMG = "https://static.prod-images.emergentagent.com/jobs/8091f325-25f0-40fb-8b3b-a6638d99e58a/images/79ed710d9778afd0a41fb013f49ca524b3135d0abb0112cbdfdf49df86d40970.png";

export default function HeroSection() {
  const scrollTo = (id) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="hero" data-testid="hero-section" className="relative overflow-hidden sm:min-h-screen sm:flex sm:items-center">

      {/* Image: natural size on mobile (no crop), absolute cover on desktop */}
      <div className="sm:absolute sm:inset-0">
        <picture>
          <source media="(max-width: 639px)" srcSet="/pictures/hero-mobile.png" />
          <img
            src="/pictures/buc10.jpg"
            alt="Mobilier personalizat premium"
            className="w-full h-auto sm:h-full sm:object-cover sm:object-center"
          />
        </picture>
        {/* Mobile gradient: dark at bottom where text sits */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/30 to-transparent sm:hidden" />
        {/* Desktop gradient: dark on left */}
        <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/40 to-transparent hidden sm:block" />
      </div>

      {/* Text: pinned to bottom on mobile, centered on desktop */}
      <div className="absolute bottom-0 left-0 right-0 z-10 sm:relative sm:z-10 sm:w-full">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 w-full pb-10 sm:py-32 lg:py-0">
          <div className="max-w-2xl">
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2, duration: 0.6 }}
              className="text-sm uppercase tracking-[0.2em] font-bold text-[#A67B5B] mb-4 sm:mb-6"
            >
              Mobilier la comandă · Dumbrăveni, Suceava
            </motion.p>

            <motion.h1
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.4, duration: 0.7 }}
              className="font-['Outfit'] text-3xl sm:text-5xl lg:text-6xl tracking-tight font-light text-white leading-[1.1] mb-4 sm:mb-6"
            >
              Mobilier creat
              <br />
              <span className="font-medium">pe măsura ta</span>
            </motion.h1>

            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.6, duration: 0.6 }}
              className="hidden sm:block text-base lg:text-lg text-white/80 leading-relaxed mb-10 max-w-lg"
            >
              Transformăm spațiile tale în locuri unice, cu mobilier personalizat din materiale premium.
              De la idee la realitate, fiecare piesă este o poveste.
            </motion.p>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.8, duration: 0.6 }}
              className="flex flex-wrap gap-3 sm:gap-4"
            >
              <button
                data-testid="hero-cta-offer"
                onClick={() => scrollTo('#contact')}
                className="group px-6 sm:px-7 py-3 sm:py-3.5 bg-[#A67B5B] text-white text-sm font-medium rounded-full hover:bg-[#8B654A] transition-all duration-300 flex items-center gap-2"
              >
                Cere ofertă
                <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
              </button>
              <button
                data-testid="hero-cta-projects"
                onClick={() => scrollTo('#portofoliu')}
                className="group px-6 sm:px-7 py-3 sm:py-3.5 border border-white/30 text-white text-sm font-medium rounded-full hover:bg-white/10 transition-all duration-300 flex items-center gap-2"
              >
                <Eye size={16} />
                Vezi proiecte
              </button>
            </motion.div>
          </div>
        </div>
      </div>

      {/* Scroll indicator — desktop only */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.2, duration: 1 }}
        className="hidden sm:flex absolute bottom-8 left-1/2 -translate-x-1/2 z-20"
      >
        <div className="w-6 h-10 border-2 border-white/40 rounded-full flex justify-center pt-2">
          <motion.div
            animate={{ y: [0, 8, 0] }}
            transition={{ repeat: Infinity, duration: 1.5 }}
            className="w-1.5 h-1.5 rounded-full bg-white/70"
          />
        </div>
      </motion.div>
    </section>
  );
}
